class ResizingScripts {

  constructor() {
    this.runResizingScripts();
  }

  runResizingScripts() {
    const mainNav = document.querySelector('.main-navigation');
    const mainNavDropdown = document.getElementById('main-navigation-collapse');
    if (mainNavDropdown != null) {
      const dropdownFrame = mainNavDropdown.querySelector('.mobile-dropdown-nav-frame');
      dropdownFrame.style.maxHeight = '';
      dropdownFrameStyle = window.getComputedStyle(dropdownFrame);
      mainNavHeight = mainNav.clientHeight;
      maxNavDropdownHeight = (window.innerHeight - mainNavHeight) + 'px';
      maxNavDropdownFrameHeight = 'calc(' + (window.innerHeight - mainNavHeight) + 'px - ' + dropdownFrameStyle.paddingTop + ' - ' + dropdownFrameStyle.paddingBottom + ')';
      dropdownFrame.style.maxHeight = maxNavDropdownHeight;
    }
    this.setAnchorOffset();
  }

  setAnchorOffset() {
    headerHeight = document.querySelector('.page-wrapper header').offsetHeight;
    document.getElementsByTagName('html')[0].style = 'scroll-padding-top:' + headerHeight + 'px';
  }

}

document.addEventListener('DOMContentLoaded', () => {
  new ResizingScripts();
})

window.addEventListener('resize', () => {
  new ResizingScripts();
})
